import uuid from 'uuid-random';
import { log } from 'log';

export class WorkerService {
    worker: Worker;

    constructor() {
        this.worker = new Worker(new URL(/* webpackChunkName: "worker" */ 'js/worker.ts', import.meta.url), { type: 'module' });
    }

    request<T, K>(workerType: string, parameters: T): Promise<K> {
        const correlationId = uuid();

        return new Promise((resolve, reject) => {
            log('workerReq', { workerType, parameters });

            const controller = new AbortController();
            const { signal } = controller;

            const messageHandler = (event: MessageEvent) => {
                const {
                    type,
                    payload,
                    time,
                    correlationId: eventCorrelationId
                } = event.data;

                if (correlationId !== eventCorrelationId) {
                    return;
                }

                if (type === 'FETCH_SUCCESS') {
                    log('workerRes', { workerType, time, parameters, data: payload.data });

                    resolve(payload.data);
                } else if (type === 'FETCH_FAILURE') {
                    log('workerErr', { workerType, time, parameters, error: payload.error });

                    reject(payload.error);
                }

                controller.abort();
            };

            const errorHandler = (event: ErrorEvent) => {
                const { message } = event;

                log('workerErr', { workerType, parameters, error: message });

                reject(event);
                controller.abort();
            };

            this.worker.addEventListener('message', messageHandler, { signal });
            this.worker.addEventListener('error', errorHandler, { signal });

            this.worker.postMessage({
                workerType,
                correlationId,
                parameters,
                time: Date.now()
            });
        });
    }
}

export const workerService = new WorkerService();
